import { render, staticRenderFns } from "./pending-evaluation.vue?vue&type=template&id=35250b10&scoped=true"
import script from "./pending-evaluation.vue?vue&type=script&lang=js"
export * from "./pending-evaluation.vue?vue&type=script&lang=js"
import style0 from "./pending-evaluation.vue?vue&type=style&index=0&id=35250b10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35250b10",
  null
  
)

export default component.exports